if (!customElements.get('feature-showcase')) {
  customElements.define(
    'feature-showcase',
    class FeatureShowcase extends window.BAO.CustomElement {
      constructor () {
        super()
      }

      connectedCallback () {
        super.connectedCallback()

        this.isTicking = false
        this.lastKnownY = window.scrollY

        this.activeCardIndex = 0

        this.requestTick = this.requestTick.bind(this)
        this.updateEl = this.updateEl.bind(this)

        this.updateEl()

        this.carousel = this.initialiseCarousel()
      }

      setupListeners () {
        super.setupListeners()

        this.onScroll = this.onScroll.bind(this)

        window.addEventListener('scroll', this.onScroll, { passive: true })
      }

      onScroll () {
        this.lastKnownY = window.scrollY

        this.requestTick()
      }

      requestTick () {
        if (!this.isTicking) requestAnimationFrame(this.updateEl)

        this.isTicking = true
      }

      updateEl () {
        this.isTicking = false

        if (window.innerWidth < 768) return
        this.handleScroll()
        this.setItemsOpacity()
      }

      handleScroll () {
        const itemEls = this.querySelectorAll(
          '[data-feature-showcase-el="item"]'
        )

        const maxItems = itemEls.length - 1

        const matchedItemIndex = Array.from(itemEls).findIndex(itemEl => {
          return (
            getOffsetTop(itemEl) + itemEl.offsetHeight >
            this.lastKnownY + window.innerHeight / 2
          )
        })

        const elementStartPoint =
          getOffsetTop(itemEls[0]) - window.innerHeight / 2
        const elementEndPoint =
          getOffsetTop(itemEls[maxItems]) - window.innerHeight / 2

        if (this.lastKnownY <= elementStartPoint) {
          this.setActiveCard(0)

          return
        }

        if (this.lastKnownY > elementEndPoint) {
          this.setActiveCard(maxItems)

          return
        }

        this.setActiveCard(matchedItemIndex)
      }

      setActiveCard (activeCardIndex) {
        if (activeCardIndex === this.activeCardIndex) return

        const mediaEls = this.querySelectorAll(
          '[data-feature-showcase-el="media"]'
        )

        this.activeCardIndex = activeCardIndex

        mediaEls.forEach(mediaEl => {
          mediaEl.setAttribute(
            'aria-hidden',
            mediaEl.dataset.index !== this.activeCardIndex.toString()
          )
        })
      }

      setItemsOpacity () {
        if (!this.offsetHeight) return

        const itemEls = this.querySelectorAll(
          '[data-feature-showcase-el="item"]'
        )

        itemEls.forEach(itemEl => {
          const elementStartPoint = getOffsetTop(itemEl) - window.innerHeight
          const elementEndPoint = elementStartPoint + window.innerHeight / 2

          if (this.lastKnownY <= elementStartPoint) {
            itemEl.style.setProperty('--Item_Opacity', 0)

            return
          }

          if (this.lastKnownY > elementEndPoint) {
            itemEl.style.setProperty('--Item_Opacity', 1)

            return
          }

          const totalScrollAmount = elementEndPoint - elementStartPoint

          const scrollYAsAPercentageOfJourney =
            1 - (this.lastKnownY - elementStartPoint) / totalScrollAmount

          itemEl.style.setProperty(
            '--Item_Opacity',
            1 - scrollYAsAPercentageOfJourney
          )
        })
      }

      initialiseCarousel () {
        if (!this.els.slide?.exists) return

        return new window.KeenSlider685(this.els.slides.element, {
          selector: this.els.slide.selector,
          loop: false,
          slides: {
            perView: 1.2,
            spacing: 0
          },
          breakpoints: {
            '(min-width: 768px)': {
              disabled: true
            }
          }
        })
      }
    }
  )
}
